(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  var toggle = document.querySelector('.site-header__mobile-toggle');
  var nav = document.querySelector('.site-header__nav');
  if (toggle && nav) {
    toggle.addEventListener('click', function() {
      var isOpen = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', isOpen);
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page"]) return;
  try {
    
  (function() {
    var backLink = document.getElementById('page-back');
    if (backLink && window.history.length > 1) {
      backLink.addEventListener('click', function(e) {
        e.preventDefault();
        window.history.back();
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (function() {
    var form = document.getElementById('pdp-form');
    if (!form) return;

    var product = null;
    try {
      var scriptEl = document.querySelector('[data-product-json]');
      if (scriptEl) product = JSON.parse(scriptEl.textContent);
    } catch(e) {}

    /* Back button with history fallback */
    var backLink = document.getElementById('pdp-back');
    if (backLink && window.history.length > 1) {
      backLink.addEventListener('click', function(e) {
        e.preventDefault();
        window.history.back();
      });
    }

    /* Mobile sticky bar */
    var stickyBar = document.getElementById('pdp-sticky-bar');
    var stickyBtn = document.getElementById('pdp-sticky-btn');
    var stickyPrice = document.getElementById('pdp-sticky-price');
    var mainAtc = form.querySelector('.pdp__add-to-cart');

    function hasSizeSelected() {
      return !!form.querySelector('.pdp__size-input:checked');
    }

    function hasSizeOption() {
      return !!form.querySelector('.pdp__size-input');
    }

    function updateStickyBtn() {
      if (!stickyBtn) return;
      if (hasSizeOption() && !hasSizeSelected()) {
        stickyBtn.textContent = 'Select a size';
      } else {
        stickyBtn.textContent = 'Add to cart';
      }
    }

    if (stickyBar && mainAtc) {
      var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          stickyBar.setAttribute('aria-hidden', entry.isIntersecting ? 'true' : 'false');
        });
      }, { threshold: 0 });
      observer.observe(mainAtc);

      updateStickyBtn();

      stickyBtn.addEventListener('click', function() {
        if (hasSizeOption() && !hasSizeSelected()) {
          var sizeFieldset = form.querySelector('.pdp__sizes');
          if (sizeFieldset) sizeFieldset.scrollIntoView({ behavior: 'smooth', block: 'center' });
          return;
        }
        form.requestSubmit();
      });
    }

    /* Swatch and size selection */
    var inputs = form.querySelectorAll('.pdp__swatch-input, .pdp__size-input');
    inputs.forEach(function(input) {
      input.addEventListener('change', function() {
        /* Update selected classes */
        var parent = this.closest('.pdp__option');
        if (this.classList.contains('pdp__swatch-input')) {
          parent.querySelectorAll('.pdp__swatch').forEach(function(s) {
            s.classList.remove('pdp__swatch--selected');
          });
          this.closest('.pdp__swatch').classList.add('pdp__swatch--selected');
        } else {
          parent.querySelectorAll('.pdp__size-btn').forEach(function(s) {
            s.classList.remove('pdp__size-btn--selected');
          });
          this.closest('.pdp__size-btn').classList.add('pdp__size-btn--selected');
        }

        /* Update variant ID if product JSON available */
        if (!product) return;
        var options = [];
        form.querySelectorAll('.pdp__swatch-input:checked, .pdp__size-input:checked').forEach(function(checked) {
          options.push(checked.value);
        });

        for (var i = 0; i < product.variants.length; i++) {
          var v = product.variants[i];
          var match = true;
          for (var j = 0; j < options.length; j++) {
            if (v.options[j] !== options[j]) { match = false; break; }
          }
          if (match) {
            document.getElementById('pdp-variant-id').value = v.id;
            /* Update price */
            var priceEl = form.closest('.pdp__info').querySelector('.pdp__price');
            if (priceEl && v.price) {
              priceEl.textContent = (v.price / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' });
            }
            /* Update button state */
            var btn = form.querySelector('.pdp__add-to-cart');
            if (btn) {
              btn.disabled = !v.available;
              btn.textContent = v.available ? btn.dataset.addText || 'Add to cart' : 'Sold out';
            }
            /* Sync sticky bar price */
            if (stickyPrice && v.price) {
              stickyPrice.textContent = (v.price / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' });
            }
            updateStickyBtn();
            break;
          }
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-grid"]) return;
  try {
    
  (function() {
    var filters = document.getElementById('shop-grid-filters');
    var cards = document.querySelectorAll('#shop-grid-items .shop-grid__card');
    if (!filters || !cards.length) return;

    filters.addEventListener('click', function(e) {
      var btn = e.target.closest('.shop-grid__pill');
      if (!btn) return;

      filters.querySelectorAll('.shop-grid__pill').forEach(function(p) {
        p.classList.remove('shop-grid__pill--active');
      });
      btn.classList.add('shop-grid__pill--active');

      var filter = btn.dataset.filter;

      cards.forEach(function(card) {
        if (filter === 'all') {
          card.classList.remove('shop-grid__card--hidden');
          return;
        }

        var parts = filter.split(':');
        var attr = parts[0] === 'org' ? card.dataset.org : card.dataset.type;
        var match = attr && attr.toLowerCase() === parts[1].toLowerCase();
        card.classList.toggle('shop-grid__card--hidden', !match);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["waitlist"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var orgSelect = document.getElementById('waitlist-org');
    var tagsInput = document.getElementById('waitlist-tags');
    if (!orgSelect || !tagsInput) return;

    orgSelect.addEventListener('change', function() {
      var val = this.value;
      tagsInput.value = val ? 'drop-list, org:' + val : 'drop-list';
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
